<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div :class="{modalContent: true}">
        <h4>Copy Content</h4>
        <div class="loadingCategory" v-if="loading"></div>
        <div class="categoryCnt" v-else>
          <div v-for="(item, i) in categories" :key="i">
            <div :class="{categoryItem: true, active: item.id === currentCategoryId}"
              v-on:click="currentCategoryId = item.id">
              <h5>{{item.name}}</h5>
            </div>
            <div v-if="item.submenu && item.submenu.length > 0">
              <div class="categorySubs" v-for="(s, i2) in item.submenu" :key="i2">
                <div :class="{categoryItem: true, subItem: true,
                  active: s.id === currentCategoryId}"
                  v-on:click="currentCategoryId = s.id">
                  <div class="submenuIcon"></div>
                  <h5>{{s.name}}</h5>
                </div>
                <div v-if="s.submenu && s.submenu.length > 0">
                  <div class="categorySubs" v-for="(s2, i3) in s.submenu" :key="i3">
                    <div :class="{categoryItem: true, subItem: true,
                      active: s2.id === currentCategoryId}"
                      v-on:click="currentCategoryId = s2.id">
                      <div class="submenuIcon"></div>
                      <h5>{{s2.name}}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" v-on:click="close()"
            v-if="!btnDisabled">Cancel</button>
          <button :class="{btn: 1, btnPrimary: 1, disabled: btnDisabled}"
            v-on:click="moveNow">
            <span v-if="btnDisabled">Copying content...</span>
            <span v-else>Copy</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      itemId: null,
      loading: true,
      btnDisabled: false,
      currentCategoryId: null,
      categories: [],
    };
  },
  methods: {
    open(d, next) {
      this.item = d.item;
      this.currentCategoryId = d.currentCategoryId;
      this.show = true;
      this.next = next;
      if (this.categories.length < 1) this.getCategories();
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
    },
    close(b) {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    moveNow() {
      this.btnDisabled = true;
      const uri = `article/${this.item.id}/category/${this.currentCategoryId}/copy`;
      this.$http.get(this.$config.uri(uri)).then((response) => {
        this.btnDisabled = false;
        this.close(true);
      });
    },
    getCategories() {
      this.loading = true;
      this.$http.get(this.$config.uri('article/categories/admin')).then((response) => {
        this.loading = false;
        this.categories = (response.data.status === 200) ? response.data.data : [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 380px;
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: -30px -40px 0;
        padding: 14px 40px 10px;
        border-bottom: #eee 1px solid;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .loadingCategory{
        height: 180px;
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 40px auto;
      }
      .categoryCnt{
        padding: 10px 40px;
        height: 400px;
        overflow-y: auto;
        margin: 0 -40px;
        .categorySubs{
          padding-left: 10px;
        }
        .categoryItem{
          margin: 0 -16px;
          padding: 7px 16px 8px;
          border-radius: 5px;
          margin-bottom: 5px;
          cursor: pointer;
          padding-left: 48px;
          position: relative;
          &:before{
            content: "";
            position: absolute;
            left: 16px; top: 10px;
            width: 20px; height: 20px;
            background-image: url(../assets/listing-black.png);
            background-size: cover;
            background-position: center;
            opacity: .6;
          }
          &.subItem{
            padding-left: 48px;
            &:before{
              display: none;
            }
            .submenuIcon{
              width: 4px; height: 14px;
              background-color: #767676;
              border-radius: 10px;
              position: absolute;
              left: 20px; top: 12px;
              &:before{
                content: "";
                position: absolute;
                left: 0; bottom: 0;
                background-color: #767676;
                border-radius: 10px;
                width: 10px; height: 4px;
              }
            }
          }
          &:hover{
            background-color: #f5f5fe;
          }
          h5{
            font-weight: normal;
            font-size: 20px;
            margin: 0;
          }
          &.active{
            color: #fff;
            background-color: #0057d8;
            &:before{
              filter: invert(1);
              opacity: 1;
            }
            &.subItem{
              .submenuIcon{
                background-color: #fff;
                &:before{
                  background-color: #fff;
                }
              }
            }
          }
        }
      }
      p{
        margin: 0;
        color: #767676;
      }
      .checkCnt{
        margin: 20px 0 6px;
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        p{
          color: red;
        }
        .checkboxOuter{
          position: absolute;
          left: -8px; top: -6px;
          width: 32px; height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover{
            background-color: #eee;
          }
          .checkbox{
            width: 14px; height: 14px;
            border-radius: 3px;
            border: #999 2px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all .2s ease;
            &.checked{
              border-color: red !important;
              background-color: red !important;
              background-image: url(../assets/checked.png);
              background-size: 14px auto;
              background-position: center;
              background-repeat: no-repeat;
              .checkInner{
              }
            }
          }
        }
        &:hover{
          .checkboxOuter{
            .checkbox{
              border-color: #444;
            }
          }
        }
      }
      .modalAction{
        margin: 0 -40px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        .btn{
          margin-left: 10px;
          &.disabled{
            background-color: #ddd;
            color: #999;
            box-shadow: none;
            cursor: default;
          }
        }
      }
    }
  }
</style>
